import { isApolloGraphQLError, isApolloNetworkError, isGraphQLError, isGraphQLErrorArray, isStringError, isStringErrorArray } from './errorGuards';
/**
 * Возвращает сообщение об ошибке из разных типов ошибок.
 *
 * Поддерживает:
 * - string
 * - string[] - берется первый элемент
 * - Error-подобные объекты (error.message)
 * - GraphQLError
 * - GraphQLError[] - берется первый элемент
 * - ApolloError (graphQLErrors[0] / networkError.message)
 *
 * Если не может определить ошибку, то вернёт значение fallback.
 *
 * @param error - Ошибка неизвестного типа.
 * @param fallback - Сообщение по умолчанию, если текста ошибки нет, по дефолту 'Unknown error'.
 * @returns  Строка с текстом ошибки.
 */
export const getErrorMessage = (error, fallback = 'Unknown error') => {
    var _a;
    if (!error) {
        return fallback;
    }
    /* string */
    if (isStringError(error)) {
        return error || fallback;
    }
    /* string[] */
    if (isStringErrorArray(error)) {
        return error[0] || fallback;
    }
    /* GraphQLError */
    if (isGraphQLError(error)) {
        return error.message || fallback;
    }
    /* GraphQLError[] */
    if (isGraphQLErrorArray(error)) {
        return ((_a = error[0]) === null || _a === void 0 ? void 0 : _a.message) || fallback;
    }
    const anyError = error;
    /* ApolloError - graphQLErrors*/
    if (isApolloGraphQLError(anyError)) {
        const first = anyError.graphQLErrors[0];
        return (first === null || first === void 0 ? void 0 : first.message) || fallback;
    }
    /* ApolloError  - networkError */
    if (isApolloNetworkError(anyError)) {
        const message = anyError.networkError.message.trim();
        return message || fallback;
    }
    /* Error */
    if (typeof anyError.message === 'string' && anyError.message.trim()) {
        return anyError.message || fallback;
    }
    return fallback;
};
